import { 
  StandingsResponse, 
  HistoricalResponse, 
  AllTimeStatsResponse 
} from '../../../shared/types';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export class StandingsService {
  static async fetchStandings(season?: number): Promise<StandingsResponse> {
    try {
      const url = season 
        ? `${API_BASE_URL}/standings?season=${season}`
        : `${API_BASE_URL}/standings/current`;
        
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data: StandingsResponse = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching standings:', error);
      throw error;
    }
  }

  static async fetchHistoricalStandings(): Promise<HistoricalResponse> {
    try {
      const response = await fetch(`${API_BASE_URL}/standings/historical`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data: HistoricalResponse = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching historical standings:', error);
      throw error;
    }
  }

  static async fetchAllTimeStats(): Promise<AllTimeStatsResponse> {
    try {
      const response = await fetch(`${API_BASE_URL}/standings/all-time`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data: AllTimeStatsResponse = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching all-time stats:', error);
      throw error;
    }
  }
}